import React, { ReactElement, useRef } from "react";
import styled from "styled-components";
import { FieldProps } from "formik";

interface FileInputProps extends FieldProps {
  label?: string;
  multiple?: boolean;
  accept?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  title?: string;
}

export const BaseFileInput: React.FC<FileInputProps> = ({
  field,
  form,
  label,
  multiple = false,
  accept,
  title,
  onChange,
}: FileInputProps): ReactElement => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const error = (form.errors as any)?.[field.name];
  const touched = (form.touched as any)?.[field.name];
  const hasError = Boolean(error && touched);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event);

    const files = event.currentTarget.files
      ? Array.from(event.currentTarget.files)
      : [];

    form.setFieldValue(field.name, files);

    event.currentTarget.value = "";
  };

  const handleBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.click();
    }
  };

  return (
    <Wrapper>
      {label && <Label>{label}</Label>}

      <HiddenInput
        ref={inputRef}
        id={field.name}
        name={field.name}
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <FakeButton type="button" onClick={handleClick}>
        {title || `Выбрать файл${multiple ? "ы" : ""}`}
      </FakeButton>

      {hasError && <ErrorText>{error}</ErrorText>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 12px;
`;

const Label = styled.div`
  margin-bottom: 6px;
  font-size: 14px;
  text-align: center;
  color: rgba(254, 255, 255, 0.8);
  font-family: "Manrope";
`;

const HiddenInput = styled.input`
  display: none;
`;

const FakeButton = styled.button`
  padding: 8px 14px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  height: 70px;
  font-family: "Manrope";
  background-color: #e46dd6a6;
  color: #ffffff;
  transition: background-color 0.15s ease, transform 0.1s ease;

  &:active {
    transform: translateY(0);
  }
`;

const ErrorText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #ff4b4b;
`;